import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { doc, setDoc, db, getDoc } from "../../firebase";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const AdminBlockAUser = ({ id, getUser }) => {
  const { t, i18n } = useTranslation();
  const [status, setStatus] = useState(null); // if block is true, status is true

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const confirm = () => {
    if (status) {
      unblock();
    } else {
      block();
    }
    handleClose();
  };

  useEffect(() => {
    const get = async () => {
      const docRef = doc(db, "users", id);
      const docSnap = await getDoc(docRef);
      console.log("docSnap.data().block", docSnap.data().block);

      if (docSnap.exists()) {
        setStatus(docSnap.data().block);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    };
    get();
    return () => {
      setStatus(null);
    };
  }, []);

  const block = async () => {
    const cityRef = doc(db, "users", id);
    setDoc(cityRef, { block: true }, { merge: true });
    setStatus(true);
    getUser();
  };
  const unblock = async () => {
    const cityRef = doc(db, "users", id);
    setDoc(cityRef, { block: false }, { merge: true });
    setStatus(false);
    getUser();
  };
  return (
    <div>
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Open alert dialog
        </Button> */}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" sx={{ my: 2, fontSize: "14px" }}>
            {status
              ? t("Unblock this user")
              : t("Are you sure you want to block this user?")}
          </DialogTitle>

          <DialogActions>
            <Button onClick={handleClose}>{t("Disagree")}</Button>
            <Button onClick={confirm} autoFocus>
              {t("Agree")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {status ? (
        <div onClick={handleClickOpen}>{t("Unblock this user")}</div>
      ) : (
        <div onClick={handleClickOpen}>{t("Block this user")}</div>
      )}
    </div>
  );
};

export default AdminBlockAUser;
